/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kpfsmultiple1Inputs */

const de__field_kpfsmultiple1 = /** @type {(inputs: _Field_Kpfsmultiple1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KPF`)
};

/**

* @param {_Field_Kpfsmultiple1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kpfsmultiple1 = /** @type {((inputs?: _Field_Kpfsmultiple1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kpfsmultiple1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kpfsmultiple1(inputs)
});
export { _field_kpfsmultiple1 as "_field_kpfsMultiple" }